module.exports = __webpack_public_path__ + "img/serenity.dfec4cf7.svg";